import { X } from 'lucide-react';
import { useState, useEffect } from 'react';
import api from '../../api';

export default function AddSubTopicModal({ handleClose, allTopics }) {
    const [topicId, setTopicId] = useState('');
    const [subTopicName, setSubTopicName] = useState('');
    const [topics, setTopics] = useState(allTopics);
    const [isLoading, setIsLoading] = useState(false);

    const handleSave = async () => {
        if (!topicId || !subTopicName.trim()) {
            return; // Don't save incomplete data
        }

        setIsLoading(true);
        try {
            const response = await api.post('/admin/add-subtopic', {
                name: subTopicName,
                topicId: topicId,
            });

            if (response.data.statusCode === 200) {
                // Successfully added subtopic
                handleClose({modalName: ""});
            } else {
                // Handle error
                console.error('Failed to add subtopic:', response.data.message);
            }
        } catch (error) {
            console.error('Error adding subtopic:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="modal modal-open">
            <div className="modal-box relative max-w-md">
                {/* Header */}
                <div className="flex items-center justify-between mb-6">
                    <h2 className="text-xl font-bold flex items-center gap-2">
                        Add SubTopic
                    </h2>
                    <button
                        onClick={() => handleClose({ modalName: '' })}
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                {/* Form */}
                <div className="form-control w-full mb-4">
                    <label className="label">
                        <span className="label-text">Select Topic</span>
                    </label>
                    <select
                        className="select select-bordered w-full"
                        value={topicId}
                        onChange={(e) => setTopicId(e.target.value)}
                    >
                        <option disabled value="">
                            Select a topic
                        </option>
                        {topics.map((topic) => (
                            <option key={topic._id} value={topic._id}>
                                {topic.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-control w-full mb-6">
                    <label className="label">
                        <span className="label-text">SubTopic Name</span>
                    </label>
                    <input
                        type="text"
                        placeholder="Enter subtopic name"
                        className="input input-bordered w-full"
                        value={subTopicName}
                        onChange={(e) => setSubTopicName(e.target.value)}
                    />
                </div>

                {/* Actions */}
                <div className="modal-action">
                    <button
                        className="btn btn-ghost"
                        onClick={handleClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={!topicId || !subTopicName.trim() || isLoading}
                    >
                        {isLoading ? (
                            <span className="loading loading-spinner loading-sm"></span>
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
